export const sliderVariants = {
  incoming: (direction) => {
    return {
      x: direction > 0 ? 1000 : -1000,
      opacity: 0,
      scale: 1,
    }
  },
  active: {
    zIndex: 1,
    x: 0,
    opacity: 1,
    scale: 1,
  },
  exit: (direction) => {
    return {
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
      scale: 1,
    }
  },
}

export const sliderTransition = {
  x: { type: 'spring', stiffness: 300, damping: 30, duration: 1 },
  opacity: { duration: 0.2 },
}
